function initToggle() {
    var toggles = document.querySelectorAll('.toggle-switch');
    if (!toggles.length) return;

    for (var i = 0; i < toggles.length; i++) {
        bindToggle(toggles[i]);
    }
}

function bindToggle(toggle) {
    toggle.addEventListener('click', function () {
        var current = toggle.getAttribute('data-state') === 'true';
        var next = !current;

        toggle.setAttribute('data-state', next ? 'true' : 'false');

        if (next) {
            onToggleTrue(toggle);
        } else {
            onToggleFalse(toggle);
        }
    });
}

function onToggleTrue(el) {
    const first = document.querySelectorAll('.first');
    const second = document.querySelectorAll('.second');
    second.forEach(el => {
        el.classList.add('primary');
        el.classList.remove('hover');
    })
    first.forEach(el => {
        el.classList.add('hover');
        el.classList.remove('primary');
    })
}

function onToggleFalse(el) {
    const first = document.querySelectorAll('.first');
    const second = document.querySelectorAll('.second');
    first.forEach(el => {
        el.classList.add('primary');
        el.classList.remove('hover');
    })
    second.forEach(el => {
        el.classList.add('hover');
        el.classList.remove('primary');
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToggle);
} else {
    initToggle();
}

document.addEventListener('shopify:section:load', initToggle);